// mui 5
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const flexColumnCenter = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

export const StyledCardContainer = styled(Card)(({ theme }) => ({
  ...flexColumnCenter,

  position: "relative",
  width: "100%",
  minWidth: "350px",
  height: "300px",
  borderRadius: "20px",
  backgroundColor: "#232323",
  overflow: "hidden",

  "& .MuiCardContent-root:last-child": {
    paddingBottom: 0,
  },

  "&:hover": {
    "& .MuiCardHeader-root": {
      top: "10%",
      transform: "translateY(10%)",
    },
    "& .MuiCardHeader-title": {
      fontSize: theme.spacing(3),
    },

    "& .MuiCardHeader-subheader": {
      fontSize: theme.spacing(2),
    },
    "#styled-card-content": {
      opacity: 1,
      visibility: "visible",
      transform: "translateY(-20px)",
    },
  },
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  ...flexColumnCenter,

  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  padding: 0,

  transition: "0.5s",

  "& .MuiCardHeader-content": {
    ...flexColumnCenter,
  },

  "& .MuiAvatar-img": {
    width: "96px",
    height: "96px",
  },

  "& .MuiCardHeader-subheader": {
    color: "#ccc",
    fontSize: theme.spacing(3),
  },
  "& .MuiCardHeader-title": {
    color: "#eee",
    fontSize: theme.spacing(4),
  },
  "& .MuiCardHeader-avatar": {
    ...flexColumnCenter,
    margin: 0,
  },
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  width: "70%",
  padding: 0,
  // border: '1px solid aqua',

  transition: ".5s ease-in-out",
  opacity: 0,
  visibility: "hidden",
}));

export const StyledPokemonTypes = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "8px",
  marginBottom: theme.spacing(2),
}));

export const StyledPokemonAbilities = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "8px",
  marginBottom: theme.spacing(2),
}));

export const StyledTypogrophy = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  letterSpacing: theme.spacing(0.125),
  textTransform: "uppercase",
  color: "#eee",
}));
